export default __webpack_public_path__ + "9b95a583956d9d9bdac1a45fbfae36e6.svg";